export const checkMaxAge = {
  getMessage: (field, args) => {
    return 'Minimum Age must be less than Maximum Age'
  },
  validate: (value, args) => {
    return !(value >= parseInt(args))
  }
}

export const checkAgeMustEnter = {
  getMessage: (field, args) => {
    if (field === "Minimum Driver's Age") {
      return 'Must key in a maximum age'
    } else {
      return 'Must key in a minimum age'
    }
  },
  validate: (value, args) => {
    return false
  }
}

export const checkHelpListField = {
  getMessage: (field, args) => {
    return field + ' Not Found'
  },
  validate: (value, args) => {
    if (args) {
      for (var i in args) {
        if (value === args[i]) {
          return true
        }
      }
      return false
    } else {
      return false
    }
  }
}

export const checkVehGrp = {
  getMessage: (field, args) => {
    return field + ' Not Found'
  },
  validate: (value, args) => {
    if (args) {
      for (var i in args) {
        if (parseInt(value) === parseInt(args[i])) {
          return true
        }
      }
      return false
    } else {
      return false
    }
  }
}

export const checkDefVehUsg = {
  getMessage: (field, args) => {
    return field + ' Not Found'
  },
  validate: (value, args) => {
    if (args) {
      for (var i in args) {
        if (parseInt(value) === parseInt(args[i])) {
          return true
        }
      }
      return false
    } else {
      return false
    }
  }
}

export const busClsAppIdList = [
  { label: 'BD - Bond', value: 'BD' },
  { label: 'CA - Cargo', value: 'CA' },
  { label: 'HU - Hull', value: 'HU' },
  { label: 'FI - Fire', value: 'FI' },
  { label: 'MI - Miscellaneous', value: 'MI' },
  { label: 'MO - Motor', value: 'MO' },
  { label: 'PA - Personal Accident', value: 'PA' }
]

export const ttyCesMethList = [
  { label: 'IN - Individual', value: 'IN' },
  { label: 'BL - Block', value: 'BL' },
  { label: 'NM - No Method', value: 'NM' }
]

export const riCatList = [
  { label: 'Bond', value: 'Bond' },
  { label: 'Cargo', value: 'Cargo' },
  { label: 'Motor', value: 'Motor' },
  { label: 'Fire', value: 'Fire' },
  { label: 'PA', value: 'PA' }
]

export const noLivesList = [
  { label: 'M - Mandatory', value: 'M' },
  { label: 'O - Optional', value: 'O' },
  { label: 'N - Not Allowed', value: 'N' }
]
